import React, { useState } from "react";

import { Divider, Grid, Box, Container, Typography } from "@mui/material";
import _ from "lodash";

import CustomLayout from "views/CustomLayout";
import CustomBreadcrumbs from "components/Breadcrumbs";
import { useSelector } from "react-redux";

import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import BannerCarousel from "views/Landing/BannerCarousel";

const bgImage = require("../../assets/images/background.jpg");

const ContactUs = ({ breadcrumbs }) => {
  const webDetails = useSelector((state) => state.webDetails);
  const { websiteInfo } = webDetails;
  const bannerUrl = _.get(websiteInfo, "banner", "") || bgImage;

  return (
    <CustomLayout>
      {/* <div
            style={{
                // backgroundImage: `url(${_.get(websiteInfo, 'banner')})`
                backgroundImage: _.get(websiteInfo, 'banner', '')
                    ? `url(${_.get(websiteInfo, 'banner')})`
                    : `url(${bgImage})`
            }} class="parallax">
                <div className="header-wrapper">
                    <span className="span-2">Contact Us</span>
                </div>
            </div> */}
      <>
        {/* ✅ Desktop View */}
        {/* <Box
                    className="parallax"
                    sx={{
                        display: { xs: "none", sm: "none", md: "block" },
                        backgroundImage: `url(${bannerUrl})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                    }}
                >
                    <div className="header-wrapper">
                        <span className="span-2">Contact Us</span>
                    </div>
                </Box> */}

        {/* ✅ Mobile View */}
        {/* <Box
                    sx={{
                        display: { xs: "block", sm: "block", md: "none" },
                        position: "relative",
                    }}
                >
                    <img
                        src={bannerUrl}
                        alt="Banner"
                        style={{
                            width: "100%",
                            height: "auto",
                            objectFit: "cover",
                        }}
                    />
                    <div
                        className="header-wrapper"
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            textAlign: "center",
                            color: "white",
                        }}
                    >
                        <span className="span-2">Contact Us</span>
                    </div>
                </Box> */}
        <BannerCarousel type={"contact"} />
      </>
      <Container maxWidth="lg" disableGutters>
        <Box
          className="content-container"
          sx={{
            maxWidth: "1250px",
            width: "100%",
            margin: "0 auto",
            px: { xs: 2, sm: 2, md: 3 },
            mb: 3,
          }}
        >
          <div className="content-container">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mb: 3,
                mt: 2,
              }}
            >
              {/* Icon Circle */}
              <Box
                sx={{
                  width: { xs: 45, md: 60 },
                  height: { xs: 45, md: 60 },
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <EmailIcon
                  sx={{
                    color: "#000",
                    fontSize: { xs: 24, md: 30 },
                  }}
                />
              </Box>

              {/* Title */}
              <Typography
                sx={{
                  fontWeight: 700,
                  fontSize: {
                    xs: "1.3rem",
                    sm: "1.6rem",
                    md: "2rem",
                  },
                }}
              >
                Contact us
              </Typography>
            </Box>

            <Grid
              container
              className="contact-wrapper main-content-wrapper"
              sx={{
                borderRadius: "1rem",
                boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
                border: "0.4px solid #e5e5e5",
                p: {
                  xs: 2,
                  sm: 3,
                  md: 4,
                },
              }}
            >
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  pr: { md: 4 },
                  borderRight: {
                    xs: "none",
                    md: "1px solid #ddd",
                  },
                  mb: { xs: 3, md: 0 },
                  lineHeight: 1.8,
                }}
              >
                <span className="content-wrapper description">
                  <div className="business-address">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: websiteInfo.business_address,
                      }}
                    />
                  </div>
                </span>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  pl: { md: 4 },
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
                className="contact-detail-wrapper"
              >
                {websiteInfo.email_address ? (
                  <div className="content-wrapper description">
                    <EmailIcon />
                    <span>{_.get(websiteInfo, "email_address")}</span>
                    <br />
                  </div>
                ) : (
                  ""
                )}
                {websiteInfo.mobile_number ? (
                  <div className="content-wrapper description">
                    <PhoneIcon />
                    <span>
                      +{_.get(websiteInfo, "country_code")}
                      {"-"}
                      {_.get(websiteInfo, "mobile_number")}
                    </span>
                    <br />
                  </div>
                ) : (
                  ""
                )}
                {websiteInfo.whatsapp ? (
                  <span className="content-wrapper description">
                    <WhatsAppIcon />+
                    {_.get(websiteInfo, "whatsapp_country_code")}
                    {"-"}
                    {_.get(websiteInfo, "whatsapp")}
                    <br />
                  </span>
                ) : (
                  ""
                )}
              </Grid>
            </Grid>
          </div>
        </Box>
      </Container>
    </CustomLayout>
  );
};

export default ContactUs;
